import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { transparentize } from 'polished'

import { Colors, Gutter } from '../../utils/styles'

export const SectionDashboardContainer = styled.div({
  background: Colors.WHITE,
  width: '100%',
})

export const SectionDashboardContentContainer = styled.div(props => ({
  background: transparentize(0.92, props.color),
  padding: `${Gutter.DOUBLE} ${Gutter.FULL}`,
  width: '100%',
  '@media (max-width: 520px)': {
    padding: `${Gutter.DOUBLE} ${Gutter.QUARTER}`,
  },
}))

SectionDashboardContentContainer.propTypes = {
  color: PropTypes.string,
}

SectionDashboardContentContainer.defaultProps = {
  color: 'yellow',
}
